export default __webpack_public_path__ + "static/media/first-names.08a9ee42.txt";